<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import DocumentList from '../Document/DocumentList.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import WalletContractInvoiceList from './WalletContractInvoiceList.vue'

export default {
  components: { WalletContractInvoiceList, DocumentList, BlockContent },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    contractId: { type: Number, required: true },
    companySalesman: { type: Object, required: false, default: null },
  },

  data: () => ({
    linkPos: 0,
  }),

  methods: {
    getActiveClass(value) {
      if (value === this.linkPos) {
        return 'sub-active'
      }

      return ''
    },
    setActive(value) {
      this.linkPos = value
    },
  },
  computed: {
    documentListAddOnly() {
      return user.isBusinessMan || this.isTheme('financia')
    },
    isCompanySalesman() {
      return user.id === this.companySalesman.id
    },
    isManagerCompanySalesman() {
      return this.hasRole('ROLE_VIEW_OTHER') && user.entity.isCompany
    },
    isAdmin() {
      return user.isAdmin
    },
    hasAccessToDocuments() {
      return this.linkPos === 0
    },
    hasAccessToInvoices() {
      return this.linkPos === 1
    },
  },
}
</script>
<template>
  <div id="portefeuille-document">
    <BlockContent>
      <div class="submenu-link">
        <a :class="getActiveClass(0)" tabindex="0" @click="setActive(0)">
          {{ $t('simulation.document.title') }}
        </a>
        <a tabindex="1" :class="getActiveClass(1)" @click="setActive(1)">
          {{ $t('invoice.list.title') }}
        </a>
      </div>
    </BlockContent>
    <BlockContent v-if="hasAccessToDocuments">
      <DocumentList
        id="portefeuille-document"
        read-only
        :add-only="documentListAddOnly"
        context="Contract"
        :context-id="contractId"
      />
    </BlockContent>
    <BlockContent v-if="hasAccessToInvoices">
      <WalletContractInvoiceList :contract-id="contractId" />
    </BlockContent>
  </div>
</template>
